export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  ACCOUNTS_PAYABLE: '/financeiro/pagar',
  ACCOUNTS_RECEIVABLE: '/financeiro/receber',
  CASH_FLOW: '/financeiro/fluxo-caixa',
  TRANSACTIONS: '/financeiro/movimentacoes',
  BANK_ACCOUNTS: '/financeiro/contas',
  CLIENTS: '/cadastros/clientes',
  CLIENT_DETAIL: '/cadastros/clientes/:id',
  SUPPLIERS: '/cadastros/fornecedores',
  SUPPLIER_DETAIL: '/cadastros/fornecedores/:id',
  PRODUCTS: '/cadastros/produtos-servicos',
  CATEGORIES: '/cadastros/categorias',
  PRODUCT_TYPES: '/cadastros/tipos',
  COST_CENTERS: '/cadastros/centros-custo',
  CONTRACTS: '/contratos',
  CONTRACT_ADJUSTMENTS: '/contratos/reajustes',
  CONTRACT_INDICES: '/contratos/indices',
  QUOTES: '/comercial/orcamentos',
  QUOTE_NEW: '/comercial/orcamentos/novo',
  QUOTE_DETAIL: '/comercial/orcamentos/:id',
  QUOTE_EDIT: '/comercial/orcamentos/:id/editar',
  BILLING: '/fiscal/faturamento',
  INVOICES: '/fiscal/notas',
  DOCUMENTS: '/gestao/documentos',
  PASSWORDS: '/gestao/senhas',
  REPORTS: '/gestao/relatorios',
  SETTINGS: '/configuracoes',
  NOT_FOUND: '*',
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  THEME: 'theme',
};

export const QUERY_KEYS = {
  HEALTH: ['health'],
  ME: ['auth', 'me'],
  DASHBOARD: ['dashboard'],
  CLIENTS: ['clients'],
  SUPPLIERS: ['suppliers'],
  PRODUCTS: ['products'],
  CONTRACTS: ['contracts'],
  CONTRACT_ADJUSTMENTS: ['contract-adjustments'],
  CONTRACT_INDICES: ['contract-indices'],
  QUOTES: ['quotes'],
  ACCOUNTS_PAYABLE: ['accounts-payable'],
  ACCOUNTS_RECEIVABLE: ['accounts-receivable'],
  TRANSACTIONS: ['transactions'],
  CASH_FLOW: ['cash-flow'],
  BANK_ACCOUNTS: ['bank-accounts'],
  BILLING: ['billing'],
  INVOICES: ['invoices'],
  DOCUMENTS: ['documents'],
  PASSWORDS: ['passwords'],
  REPORTS: ['reports'],
  USERS: ['users'],
  ORGANIZATION: ['organization'],
  CATEGORIES: ['categories'],
  PRODUCT_TYPES: ['product-types'],
  COST_CENTERS: ['cost-centers'],
  NOTIFICATIONS: ['notifications'],
};

export const BRAZIL_STATES = [
  { uf: 'AC', name: 'Acre' },
  { uf: 'AL', name: 'Alagoas' },
  { uf: 'AP', name: 'Amapá' },
  { uf: 'AM', name: 'Amazonas' },
  { uf: 'BA', name: 'Bahia' },
  { uf: 'CE', name: 'Ceará' },
  { uf: 'DF', name: 'Distrito Federal' },
  { uf: 'ES', name: 'Espírito Santo' },
  { uf: 'GO', name: 'Goiás' },
  { uf: 'MA', name: 'Maranhão' },
  { uf: 'MT', name: 'Mato Grosso' },
  { uf: 'MS', name: 'Mato Grosso do Sul' },
  { uf: 'MG', name: 'Minas Gerais' },
  { uf: 'PA', name: 'Pará' },
  { uf: 'PB', name: 'Paraíba' },
  { uf: 'PR', name: 'Paraná' },
  { uf: 'PE', name: 'Pernambuco' },
  { uf: 'PI', name: 'Piauí' },
  { uf: 'RJ', name: 'Rio de Janeiro' },
  { uf: 'RN', name: 'Rio Grande do Norte' },
  { uf: 'RS', name: 'Rio Grande do Sul' },
  { uf: 'RO', name: 'Rondônia' },
  { uf: 'RR', name: 'Roraima' },
  { uf: 'SC', name: 'Santa Catarina' },
  { uf: 'SP', name: 'São Paulo' },
  { uf: 'SE', name: 'Sergipe' },
  { uf: 'TO', name: 'Tocantins' },
];

export function clientDetailPath(id) {
  return `/cadastros/clientes/${id}`;
}

export function supplierDetailPath(id) {
  return `/cadastros/fornecedores/${id}`;
}

export function quoteDetailPath(id) {
  return `/comercial/orcamentos/${id}`;
}

export function quoteEditPath(id) {
  return `/comercial/orcamentos/${id}/editar`;
}

/** Destination after login / when leaving public auth routes. */
export function getPostAuthPath(user) {
  return user?.organizationId ? ROUTES.DASHBOARD : ROUTES.SETTINGS;
}
